import React from 'react';
import CreateModal from './CreateModal';

const DispatchContext = React.createContext(undefined);

const initState = {
  shown: false,
  title: '',
  onDelete: () => {},
  onSave: () => {},
  onChange: () => {},
  fields: [],
  formState: {},
  errorText: ''
};

function Reducer(state, action) {
  var stateUpdates = {};

  switch (action.action) {
    case 'open':
      stateUpdates = {
        shown: true,
        fields: action.fields,
        formState: action.formState || [],
        onSave: action.onSave ?? (() => {}),
        onChange: action.onChange ?? (() => {}),
        onDelete: action?.onDelete ?? (() => {}),
        title: action.title
      };
      break;
    case 'close':
      stateUpdates = {
        shown: false
      };
      break;
    case 'setFormState':
      const newS = {
        ...state,
        formState: action.formState
      };
      return newS;
    case 'error':
      stateUpdates = {
        ...state,
        errorText: action.error
      };
      break;
    default:
      throw new Error('No action given');
  }

  var newState = { ...initState, ...stateUpdates };
  return newState;
}

function CreateModalProvider({ children }) {
  const [state, dispatch] = React.useReducer(Reducer, initState);

  return (
    <DispatchContext.Provider value={dispatch}>
      <CreateModal
        open={state.shown}
        onClose={() => {
          dispatch({
            action: 'close'
          });
        }}
        onSave={async () => {
          const { success, error } = await state.onSave(state.formState);
          if (success) {
            dispatch({
              action: 'close'
            });
          } else {
            dispatch({
              action: 'error',
              error: error || { message: 'Unable to save item' }
            });
          }
        }}
        cardTitle={state.title}
        fields={state.fields}
        error={state.errorText}
        formState={state.formState}
        setFormState={val => {
          dispatch({
            action: 'setFormState',
            formState: val
          });
          state.onChange(val);
        }}
      />
      {children}
    </DispatchContext.Provider>
  );
}

function useCreateModalDispatch() {
  const context = React.useContext(DispatchContext);
  if (context === undefined) {
    throw new Error(
      'CreateModalDispatch must be used with CreateModalProvider'
    );
  }
  return context;
}

export { CreateModalProvider, useCreateModalDispatch };
